/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsmembersempty2Inputs */

const en_groupsmembersempty2 = /** @type {(inputs: Groupsmembersempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody here yet. Share the invite link.`)
};

const de_groupsmembersempty2 = /** @type {(inputs: Groupsmembersempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch niemand dabei. Teile den Einladungslink.`)
};

/**
* | output |
* | --- |
* | "Nobody here yet. Share the invite link." |
*
* @param {Groupsmembersempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsmembersempty2 = /** @type {((inputs?: Groupsmembersempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsmembersempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsmembersempty2(inputs)
	return de_groupsmembersempty2(inputs)
});
export { groupsmembersempty2 as "groupsMembersEmpty" }